import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import React from "react";
interface DatePickerProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: DateState;
    settings: any;
}

export class KendoDatePicker extends React.Component<DatePickerProps, any>{
    private datePicker;

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        let date;
        if (this.props.values) {
            date = this.props.values[this.props.settings.name];
        }

        var config = {
            change: function () {
                var value = this.value();
                that.props.onTextChange(that.props.settings.name, value ? value.toISOString() : value);
            }
        };


        var that = this;
        var $rootNode = $(this.refs.datePicker);

        this.datePicker = $rootNode.kendoDatePicker(config);

        this.setDate(date);
    }

    setDate = (date) => {
        let $el = this.refs.datePicker;
        let pDate = null;
        let timestamp = Date.parse(date)

        if (isNaN(timestamp)) {
            pDate = kendo.parseDate(date, "dd.MM.yyyy");
        }
        else {
            pDate = new Date(timestamp);
        }

        if ($el) {
            var picker = $($el).data("kendoDatePicker");


            if (!picker.value() || picker.value().toISOString() != date) {
                picker.value(pDate);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.values) {
            this.setDate(this.props.values[this.props.settings.name]);
        }
    }

    render() {
        var style = { width: "100%" };
        return (<react_components.ReactColumn width={this.props.metadataSettings.width}>
            <div className="form-group">
                <react_components.TruncatedLabel>{this.props.settings.label}</react_components.TruncatedLabel>
                <input ref="datePicker" style={style} ></input>
            </div>
        </react_components.ReactColumn>)
    }
};

export class DateState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private isMandatoryMetadata = new propertyTypes.CheckBoxProperty("isMandatory", "Is mandatory?");
    public isMandatory: string;

    private dataMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.getNameMetadata().SetMandatory(true);
        const baseMetaData = super.getMetadata();
        this.dataMetadataAll = baseMetaData.concat([this.labelMetadata, this.isMandatoryMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.dataMetadataAll;
    }
}